import request from "@/utils/request";

// 列表(主数据列表)
export function loadMarketProductRealListDataApi(data) {
  return request({
    url: "web/marketProductReal/listData",
    method: "post",
    data
  });
}
// 导出
export function loadMarketProductRealExportDataApi(data) {
  return request({
    url: "web/marketProductReal/exportData",
    method: "post",
    data
  });
}
// 初始化
export function initMarketProductRealApi(data) {
  return request({
    url: "web/marketProductReal/init",
    method: "post",
    data
  });
}
// 操作
export function saveOrUpdateMarketProductRealApi(data) {
  return request({
    url: "web/marketProductReal/saveOrUpdate",
    method: "post",
    data
  });
}
